export const COLORS = {
  grey: '#676767',
  silver: '#d2d4da',
  white: '#FFFFFF',
  black: '#000000',
  blue: '#0084ff',
  green: '#4CAF50',
  red: '#C62828'
}

// Facebook App Id.
// Depending on the deployed Context (environment), we use the production or
// the staging App. `CONTEXT` is an env-var provided by Netlify.
// https://www.netlify.com/docs/continuous-deployment/#build-environment-variables
export const APP_ID =
  process.env.REACT_APP_CONTEXT === 'production'
    ? process.env.REACT_APP_PRODUCTION_FACEBOOK_APP_ID
    : process.env.REACT_APP_STAGING_FACEBOOK_APP_ID



// WEBPACK FOOTER //
// ./src/config.js